import styles from "./landing-page.module.scss";
import { useNavigate } from "react-router-dom";
import Footer from "../footer/footer";

function LandingPage() {
    const navigate = useNavigate();

    const handleCreateEvent = () => {
        navigate("/create");
    };

    return (
        <>

            <div className={styles.container}>
                <div className={styles.content}>
                    <img
                        src="/invitify_logo.png"
                        alt="Invitify Logo"
                        className={styles.logo}
                    />
                    <p className={styles.description}>
                        Create Party Invitations and Let Your Guests Respond!
                    </p>
                    <button
                        className={styles.createButton}
                        onClick={handleCreateEvent}
                    >
                        Create Event
                    </button>
                </div>
            </div>
            <div className={styles.footer}>
                <Footer />
            </div>
        </>
    );
}

export default LandingPage;
